import {Directive, Renderer2, ElementRef} from '@angular/core';

/**
 * Compute the position for a dropdwon : above or below its parent
 * If above, add a bottom:< dropdown height + margin >px style to the element
 */
@Directive({
  selector: '[dropdown-position]'
})
export class DropdownPositionDirective {

  private _el: ElementRef;
  private _renderer: Renderer2;

  // Margin above or below the parent element
  private _margin: number = 10;

  constructor(el: ElementRef, renderer: Renderer2) {
      this._el=el;
      this._renderer = renderer;
  }

  ngAfterViewInit() {
    let boundingBox = this._el.nativeElement.getBoundingClientRect();
    let boundingBoxParent = this._el.nativeElement.parentElement.getBoundingClientRect();
    // Compute the available space above and below the parent, adding a margin to take into account for the space
    //    between the current element and the parent
    let spaceAvailableBelowParent = window.innerHeight - boundingBoxParent.top - boundingBoxParent.height - this._margin;
    let spaceAvailableAboveParent = boundingBoxParent.top - this._margin;
    // If there is not enough space below (the default position) and that there is enough space above, then position
    //    the element above its parent
    if (spaceAvailableBelowParent < boundingBox.height && spaceAvailableAboveParent > boundingBox.height){
        // Position the element above the parent element
        // (starting from parent bottom, add the parent height + a margin )
        this._renderer.setStyle( this._el.nativeElement, 'bottom', boundingBoxParent.height + this._margin + 'px' );
    }
  }

}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/directives/dropdown-position.directive.ts